module.exports = __webpack_public_path__ + "img/SDG-10-EN-INVERTED.7f813fa9.png";